import React, { useState } from 'react'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { extractDomainZone } from '../../../../shared/lib/helpers/ExtractDomainZone'
import { URL_PROTOCOL_REGEX, URL_REGEX } from '../../../../shared/consts/RegularExpressions.const'
import styles from './AddDomain.module.scss'

interface Props {
  domains?: string[]
  currentDomains: string[]
  onSubmit: (string: string) => void
}

export const AddDomain = ({ domains, currentDomains, onSubmit }: Props) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const [isFocus, setIsFocus] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  const getDomainError = (url: string) => {
    if (!url && isFocus) {
      return t('fields.validate.domainRequired')
    }

    if (url && !URL_PROTOCOL_REGEX.test(url)) {
      return t('pages.project.validate.startWithHttp')
    }

    if (url && !URL_REGEX.test(url)) {
      return t('pages.project.validate.invalidUrl')
    }

    const cleaned = extractDomainZone(url.toLowerCase(), domains)

    if (currentDomains.some((domain) => domain.toLowerCase() === cleaned)) {
      return t('pages.project.validate.domainAlreadyExists')
    }
  }

  const error = getDomainError(value)

  return (
    <div className={styles.root}>
      <div className={styles.titleWrap}>
        <h3 className={styles.title}>
          {t('pages.project.addDomain')}
        </h3>
      </div>
      <div className={styles.body}>
        <BpInput
          required
          error={error}
          placeholder={'https://brand-domain.com'}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={() => setIsFocus(true)}
        />
      </div>
      <div className={styles.footer}>
        <BpButton
          className={styles.addButton}
          disabled={!value || !!error}
          type='button'
          onClick={() => {
            onSubmit(value)
            dispatch(hideModal())
          }}
        >
          {t('buttons.add')}
        </BpButton>
        <BpButton theme='transparent' type='button' onClick={() => dispatch(hideModal())}>
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </div>
  )
}
